/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-cycle */
import React, { ChangeEvent, FormEvent, useState } from 'react';
import styles from './popUp.module.scss';
import {
  PopUpRegistrationInterface,
  RegistrationInterface,
} from './popUpTypes';
import '../../constants/_global.scss';
import { ReactComponent as XIcon } from '../../assets/x.svg';
import Input from '../../UI/input/inputComponent';
import { INPUT_TYPE } from '../../UI/input/inputTypes';
import Button from '../../UI/button/buttonComponent';
import { BUTTON_TYPE, BUTTON_VER } from '../../UI/button/buttonTypes';
import { useDispatch, useSelector } from '../../index';
import { setError, signup } from '../../service/UserData';

const PopUpRegistration: React.FC<PopUpRegistrationInterface> = ({
  error,
  onClose,
  toLogin,
  onSubmit,
}) => {
  const dispatch = useDispatch();
  const err = useSelector((state) => state.userData.error);
  const [errStatus, setErrStatus] = useState<boolean>(false);
  const [errText, setErrText] = useState<string | null>(null);
  const text = {
    title: 'Зарегистрироваться',
    registrationProceed: 'Создать аккаунт',
    emailErrText: 'Неверный Email',
    passwordErrText: 'Неверный Пароль',
    placeholderEmail: 'Введите Email',
    placeholderPassword: 'Пароль',
    placeholderPasswordAccept: 'Повторите пароль',
    toLogin: 'Уже есть аккаунт',
    name: 'Имя',
  };

  const [formData, setFormData] = useState<RegistrationInterface>({
    email: ' ',
    password: ' ',
    submitPassword: ' ',
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    console.log(formData);
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (formData.password !== formData.submitPassword) {
      setErrStatus(true);
      setErrText('Пароли не совпадают');
    } else if (formData.password === formData.submitPassword) {
      const resultAction = await dispatch(signup(formData));

      if (signup.rejected.match(resultAction)) {
        setErrStatus(true);
        setErrText(err as string);
      } else if (signup.fulfilled.match(resultAction)) {
        dispatch(setError(null));
        onSubmit(2);
      }
    }
  };

  return (
    <form className={styles.shell} onSubmit={handleSubmit}>
      <div className={styles.titleRow}>
        <h1 className="h1">{text.title}</h1>
        <button type="button" className={styles.XBtn} onClick={onClose}>
          <XIcon />
        </button>
      </div>
      <div className={styles.inputColumn}>
        <Input
          ver={INPUT_TYPE.REGULAR}
          errStatus={errStatus}
          errMessage={errText !== null ? errText : ''}
          placeholder={text.placeholderEmail}
          customWidth={472}
          onChange={handleChange}
          name="email"
        />
        <Input
          ver={INPUT_TYPE.PASSWORD}
          errStatus={errStatus}
          errMessage={' '}
          placeholder={text.placeholderPassword}
          customWidth={312}
          name="password"
          onChange={handleChange}
        />
        <Input
          ver={INPUT_TYPE.PASSWORD}
          errStatus={errStatus}
          errMessage={' '}
          placeholder={text.placeholderPasswordAccept}
          customWidth={312}
          name="submitPassword"
          onChange={handleChange}
        />
      </div>
      <div className={styles.buttonRow}>
        <Button
          ver={BUTTON_VER.primary}
          type={BUTTON_TYPE.Submit}
          customWidth={192}
          text={text.registrationProceed}
          onClick={() => console.log('click')}
        />
        <Button
          ver={BUTTON_VER.secondary}
          type={BUTTON_TYPE.Button}
          text={text.toLogin}
          customWidth={192}
          onClick={toLogin}
        />
      </div>
    </form>
  );
};

export default PopUpRegistration;
